<template>
  <div class="wrapper">
    <h1 class="text-[#2c2c31]">Well this is awkward</h1>
    <h3 class="text-[#2c2c31]">We promise this doesn’t happen all of the time</h3>
    <router-link :to="homePath">
      <Button label="Go Back to Home page" />
    </router-link>
  </div>
</template>

<script>
import * as tmi from "@/constants";

export default {
  name: 'ServerError',
  computed: {
    homePath() {
      return tmi.HomePath;
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 50px 0 75px 0;

  .img-wrapper {
    max-width: 780px;
    max-height: 400px;
    margin-bottom: 80px;
  }
}
</style>
